import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchPosts } from "../services/homeApi";
import Footer from "../components/Home/Footer";
import "./Konsultasjoner.css";

function Konsultasjoner() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPosts()
      .then(setPosts)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="kl-page">

      {/* Page header */}
      <div className="kl-header">
        <div className="kl-header-inner">
          <span className="kl-eyebrow">Al-Yasin Koranskole</span>
          <h1 className="kl-title">Koranstimer</h1>
          <p className="kl-subtitle">
            Meld deg på en av våre kommende undervisningstimer i tilawa og tajweed
          </p>
        </div>
      </div>

      {/* List */}
      <div className="kl-body">
        <div className="kl-container">

          {loading && (
            <div className="kl-loading">
              <div className="spinner-border" style={{ color: "#d4af37" }} />
            </div>
          )}

          {!loading && posts.length === 0 && (
            <div className="kl-empty">
              <span className="kl-empty-icon">📖</span>
              <p>Ingen koranstimer er planlagt ennå. Kom tilbake snart.</p>
            </div>
          )}

          {!loading && posts.length > 0 && (
            <div className="kl-grid">
              {posts.map((post) => {
                const dateObj = post.date ? new Date(post.date + "T00:00:00") : null;
                const day = dateObj ? dateObj.getDate() : "--";
                const month = dateObj
                  ? dateObj.toLocaleString("no-NO", { month: "short" }).toUpperCase()
                  : "";
                const weekday = dateObj
                  ? dateObj.toLocaleString("no-NO", { weekday: "long" })
                  : "";

                return (
                  <div
                    key={post.id}
                    className="kl-card"
                    onClick={() => navigate(`/konsultasjoner/${post.id}`)}
                  >
                    <div className="kl-card-date">
                      <span className="kl-date-day">{day}</span>
                      <span className="kl-date-month">{month}</span>
                    </div>

                    <div className="kl-card-body">
                      {weekday && <span className="kl-card-weekday">{weekday}</span>}
                      <h3 className="kl-card-title">{post.header}</h3>
                      {post.description && (
                        <p className="kl-card-desc">{post.description}</p>
                      )}
                      <div className="kl-card-meta">
                        {post.time && <span className="kl-chip">🕐 {post.time}</span>}
                      </div>
                    </div>

                    <div className="kl-card-arrow">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Konsultasjoner;
